import {AppHeaderCrossBrandListDefaultBox} from "./app-header-cross-brand-list.default.box";
import styled from "styled-components";
import {baseColors} from "../../../../../../themes/definitions/casino888/cis/base-colors";

export const AppHeaderCrossBrandListCasino888CisBox = styled(AppHeaderCrossBrandListDefaultBox)`
  background-color: ${baseColors.black};
  color: #cccccc;
`